<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Risk Registry</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight px-0">
    <!-- FILTER -->
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group row my-0 d-flex align-items-end">
        <div class="col-12 col-lg-3 px-1">
          <label class="mb-0">Risk ID</label>
          <input type="text" v-model="searchField.riskId" class="form-control" placeholder="Risk ID"
            @keyup.enter="searchReports" />
        </div>

        <div class="col-12 col-lg-3 px-1">
          <label class="mb-0">CTQ ID</label>
          <input type="text" v-model="searchField.ctqId" class="form-control" placeholder="CTQ ID"
            @keyup.enter="searchReports" />
        </div>

        <div class="col-12 col-lg-5 px-1">
          <label class="mb-0">Risk Category</label>
          <input type="text" v-model="searchField.riskCategory" class="form-control" placeholder="Risk Category"
            @keyup.enter="searchReports" />
        </div>

        <div class="col-12 col-lg-1 px-1">
          <span class="save_btn w-100 d-inline-block text-center" @click="searchReports">
            Search
          </span>
        </div>
      </div>
    </div>

    <!-- TABLE -->
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex align-items-center justify-content-between">
        <h5 class="mt-0">Risk Registry List</h5>
        <div v-if="rollsprivilages.includes('Risk Registry Add')" class="position-relative align-self-center">
          <img
            src="@/assets/img/create.png"
            width="17"
            alt="Add Risk"
            style="cursor: pointer"
            @click="openManageRiskModal()"
          />
          <div class="tool-tip">Add Risk</div>
        </div>
      </div>

      <div class="ibox-content p-1">
        <!-- LOADER -->
        <div class="text-center" v-if="loading">
          <img src="../../assets/img/loading.gif" width="15" />
          <div>Please wait while the list is being loaded</div>
        </div>

        <!-- NO DATA -->
        <div class="text-center" v-else-if="!riskList.length">
          No data available
        </div>

        <div v-else>
          <div class="table-responsive" style="overflow-x: auto;">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                 <th class="sort_block" @click="sortSelected('ctqId')">
                    <div class="d-flex justify-content-between">
                      CTQ ID
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th class="sort_block" @click="sortSelected('riskId')">
                    <div class="d-flex justify-content-between">
                      Risk ID
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th>Category</th>
                  <th>Sub-Category</th>
                  <th class="sort_block" @click="sortSelected('riskStatement')">
                    <div class="d-flex justify-content-between">
                      Risk Statement
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th>Risk Level</th>
                  <th class="sort_block" @click="sortSelected('rpn')">
                    <div class="d-flex justify-content-between">
                      RPN
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th v-if="rollsprivilages.includes('Risk Registry Edit')" class="text-center">Edit</th>
                  <th class="text-center">Mitigations</th>
                  <th class="text-center">KRI</th>
                  <th class="text-center">View</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in riskList" :key="item.id">
                   <td>{{ item.ctqId }}</td>
                  <td> <span>{{ item.riskId }}</span> </td>
                  <td>{{ item.riskCategory }}</td>
                  <td>{{ item.subCategory }}</td>
                  <td style="max-width: 400px; white-space: normal; word-break: break-word;">
                    <span>
                      {{
                        item.expanded
                          ? item.riskStatement
                          : truncate(item.riskStatement)
                      }}
                    </span>
                    <a
                      v-if="
                        item.riskStatement && item.riskStatement.length > 120
                      "
                      class="more-less-link ms-1"
                      @click.stop="toggleExpand(item)"
                    >
                      {{ item.expanded ? "less" : "more" }}
                    </a>
                  </td>
                  <td>
                    <span :class="riskLevelBadgeClass(item.riskLevel)">{{
                      item.riskLevel
                    }}</span>
                  </td>
                  <td>{{ item.rpn }}</td>
                  <td v-if="rollsprivilages.includes('Risk Registry Edit')" class="text-center">
                    <i
                      class="fa fa-edit edit-delete"
                      title="Edit Risk"
                      @click="openManageRiskModal(item)"
                    ></i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      title="View Mitigations"
                      @click="ViewMitigation(item)"
                    ></i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      title="View KRI's"
                      @click="viewKriForRisk(item)"
                    ></i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      title="View Risk"
                      @click="viewRisk(item)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mx-0 mt-3" v-if="totalPages > 1">
            <div class="col-12 d-flex justify-content-end">
              <VPagination
                v-model="currentPage"
                :pages="totalPages"
                :range-size="1"
                active-color="#618bd7"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <KriInfoModal
    v-if="showKriModal"
    :data="selectedCtqForKri"
    @closeModal="closeKriModal"
  />

  <MitigationInfoModal
    v-if="showMitigationModal"
    :data="selectedCtqForMitigation"
    fromPage="riskRegistry"
    @closeModal="closeMitigationModal"
  />

  <ManageRiskItemModal
    v-if="showManageRiskModal"
    :riskEditData="riskEditData"
    :ctqData="manageRiskCtqContext"
    fromPage="Risk Registry"
    @closeModal="closeManageRiskModal"
    @reloadList="reloadRiskList"
  />

  <ViewRiskInfoModal
    v-if="showViewRiskModal"
    :data="selectedRiskForView"
    @closeModal="closeViewRiskModal"
  />
</template>
<script src="./RiskRegistry.js"></script>
<style scoped>
.ibox-title {
    padding: 2px 15px 8px 15px;
    min-height: 36px;
}
.sort_block {
  cursor: pointer;
}
.more-less-link {
    color: #618bd7 !important;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    user-select: none;
    text-decoration: none;
}
.more-less-link:hover {
    text-decoration: underline !important;
}
.position-relative .tool-tip {
    right: 18px;
    top: 0px;
}
</style>